var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMissionCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 21.6947C6.52683 21.6947 2.08327 17.362 2.00392 11.9843C2.00392 12.0352 2.00392 12.0861 2.00392 12.137C2.00392 17.5851 6.47922 22 12.0019 22C17.5247 22 22 17.5851 22 12.137C22 6.68883 22 12.0352 22 11.9843C21.9166 17.362 17.4731 21.6947 12.0059 21.6947H11.998Z",
    fill: "#FF8500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 21.726C17.5198 21.726 21.996 17.3102 21.996 11.863C21.996 6.41582 17.5198 2 11.998 2C6.47626 2 2 6.41582 2 11.863C2 17.3102 6.47626 21.726 11.998 21.726Z",
    fill: "url(#paint0_linear_1745_67381)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.999
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.998 3.93347C7.55845 3.93347 3.95996 7.48337 3.95996 11.863C3.95996 16.2427 7.55845 19.7926 11.998 19.7926C16.4376 19.7926 20.0361 16.2427 20.0361 11.863C20.0361 7.48337 16.4376 3.93347 11.998 3.93347Z",
    fill: "#8743FF"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.998 3.93347C7.55845 3.93347 3.95996 7.48337 3.95996 11.863C3.95996 16.2427 7.55845 19.7926 11.998 19.7926C16.4376 19.7926 20.0361 16.2427 20.0361 11.863C20.0361 7.48337 16.4376 3.93347 11.998 3.93347Z",
    fill: "url(#paint1_linear_1745_67381)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 20.0705C7.41162 20.0705 3.67824 16.3875 3.67824 11.863C3.67824 7.33855 7.41162 3.65558 11.998 3.65558C16.5844 3.65558 20.3178 7.33855 20.3178 11.863C20.3178 16.3875 16.5844 20.0705 11.998 20.0705ZM11.998 4.20744C7.71712 4.20744 4.23765 7.63992 4.23765 11.863C4.23765 16.0861 7.71712 19.5186 11.998 19.5186C16.2789 19.5186 19.7584 16.0861 19.7584 11.863C19.7584 7.63992 16.2789 4.20744 11.998 4.20744Z",
    fill: "#FF8500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 17.8317C8.61774 17.8317 5.86829 15.1194 5.86829 11.7847C5.86829 8.45009 8.61774 5.73776 11.998 5.73776C15.3783 5.73776 18.1278 8.45009 18.1278 11.7847C18.1278 15.1194 15.3783 17.8317 11.998 17.8317ZM11.998 6.12915C8.83595 6.12915 6.26503 8.66535 6.26503 11.7847C6.26503 14.9041 8.83595 17.4403 11.998 17.4403C15.1601 17.4403 17.731 14.9041 17.731 11.7847C17.731 8.66535 15.1601 6.12915 11.998 6.12915Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9147 15.9413C9.59376 15.9413 7.70921 14.0783 7.70921 11.7926C7.70921 9.50684 9.59773 7.64383 11.9147 7.64383C14.2317 7.64383 16.1202 9.50684 16.1202 11.7926C16.1202 14.0783 14.2317 15.9413 11.9147 15.9413ZM11.9147 8.06653C9.83181 8.06653 8.1377 9.73776 8.1377 11.7926C8.1377 13.8474 9.83181 15.5186 11.9147 15.5186C13.9976 15.5186 15.6918 13.8474 15.6918 11.7926C15.6918 9.73776 13.9976 8.06653 11.9147 8.06653Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 14.3366C10.6769 14.3366 9.60168 13.2759 9.60168 11.9726C9.60168 10.6693 10.6769 9.60861 11.998 9.60861C13.3192 9.60861 14.3944 10.6693 14.3944 11.9726C14.3944 13.2759 13.3192 14.3366 11.998 14.3366Z",
    fill: "#FF8500"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 14.1135C10.6769 14.1135 9.60168 13.0528 9.60168 11.7495C9.60168 10.4462 10.6769 9.38553 11.998 9.38553C13.3192 9.38553 14.3944 10.4462 14.3944 11.7495C14.3944 13.0528 13.3192 14.1135 11.998 14.1135Z",
    fill: "url(#paint2_linear_1745_67381)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 13.683C10.9824 13.683 10.1532 12.8649 10.1532 11.863C10.1532 10.861 10.9824 10.043 11.998 10.043C13.0137 10.043 13.8429 10.861 13.8429 11.863C13.8429 12.8649 13.0137 13.683 11.998 13.683Z",
    fill: "url(#paint3_linear_1745_67381)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M2.26584 9.53032L11.641 12.4697C12.248 12.5675 12.486 11.5342 12.1885 11.456L2.58324 8.41095L2.26981 9.53032H2.26584Z",
    fill: "url(#paint4_radial_1745_67381)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3145 11.0969C12.3145 11.0928 12.3145 11.0888 12.311 11.0888H12.3041C12.3041 11.0847 4.67777 3.86831 4.67777 3.86831C4.62266 3.81516 4.58821 3.73339 4.58477 3.65162L4.53999 2.33509C4.53999 2.24923 4.5021 2.17155 4.44699 2.1184L2.29067 0.0659261C2.23555 0.0168631 2.17355 -0.00357985 2.11499 0.000508731C1.91176 0.000508731 1.59486 0.307153 1.60519 0.523848L1.67753 1.89761C1.67753 1.96303 1.69131 1.99165 1.69131 2.00392L0.475362 2.13475C0.475362 2.13475 0.468473 2.13475 0.465028 2.13475L0.341023 2.14702C0.117124 2.17155 -0.113664 2.69898 0.0620101 2.86661L2.25622 4.95587C2.30444 5.00085 2.363 5.02538 2.42501 5.02129L3.69262 4.93543C3.75462 4.93134 3.81318 4.95588 3.8614 5.00085L11.3879 12.1027C11.6875 12.3562 12.1216 12.3235 12.3799 11.9842C12.4075 11.9596 12.7554 11.5017 12.3145 11.0969Z",
    fill: "#FF8500"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.392686 2.68263L2.5869 4.7719C2.63512 4.81687 2.69368 4.84141 2.75568 4.83732L4.02329 4.75146C4.0853 4.74737 4.14386 4.7719 4.19208 4.81687L11.784 11.9923C11.9803 12.1763 12.2662 12.1477 12.4316 11.9228C12.6038 11.6857 12.5762 11.3218 12.3696 11.1256L4.72599 3.89285C4.67088 3.8397 4.63643 3.75793 4.63299 3.67616L4.58821 2.35963C4.58821 2.27377 4.55032 2.19609 4.4952 2.14294L2.33889 0.0904678C2.1701 -0.068987 1.92209 0.0822906 1.93587 0.339872L2.0082 1.71364C2.01509 1.87309 1.9152 2.0121 1.78086 2.02437L0.527025 2.15929C0.303126 2.18382 0.220456 2.51909 0.392686 2.68263Z",
    fill: "url(#paint5_linear_1745_67381)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1745_67381",
    x1: 13.7318,
    y1: 21.5773,
    x2: 10.3507,
    y2: 2.13301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF962E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD278"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1745_67381",
    x1: 11.887,
    y1: 16.2309,
    x2: 12.246,
    y2: 1.72579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1745_67381",
    x1: 11.998,
    y1: 14.1135,
    x2: 11.998,
    y2: 9.38553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF962E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD278"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1745_67381",
    x1: 11.998,
    y1: 10.043,
    x2: 11.998,
    y2: 13.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFF3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFF3C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFF3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF3B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF3B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1745_67381",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.23025 10.433) rotate(-22.8202) scale(3.95531 3.91808)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1745_67381",
    x1: 11.0641,
    y1: 10.4346,
    x2: 2.09135,
    y2: 4.50645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF962E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD278"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMissionCompleted);
export default __webpack_public_path__ + "static/media/icon-mission-completed.59821d794c04eb68bd83eaf1b6000c90.svg";
export { ForwardRef as ReactComponent };